module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_3009.40d3a3fc.png";